import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class VideoCard extends Base {
  static config = {
    name: 'VideoCard',
    refs: ['play', 'volume', 'poster', 'youtubeContainer'],
    options: {
      youtubeId: {
        type: String,
        default: '',
      },
    },
  };

  youtubeIframe = null;

  youtubePlaying = false;

  /**
   * @returns {boolean}
   */
  get isYoutube() {
    return this.$options.youtubeId !== '';
  }

  /**
   * @returns {HTMLVideoElement}
   */
  get videoEl() {
    return this.$el.querySelector('video');
  }

  /**
   *
   */
  onPlayClick() {
    if (this.isYoutube) {
      this.handleYoutubePlay();
    } else {
      this.handleNativePlay();
    }
  }

  /**
   *
   */
  handleNativePlay() {
    if (this.videoEl.paused) {
      this.videoEl.play();
      this.$refs.play.querySelector('.video-play').classList.add('hidden');
    } else {
      this.videoEl.pause();
      this.$refs.play.querySelector('.video-play').classList.remove('hidden');
    }
  }

  /**
   *
   */
  handleYoutubePlay() {
    if (!this.youtubeIframe) {
      this.createYoutubeIframe();
      return;
    }

    if (this.youtubePlaying) {
      this.postYoutubeCommand('pauseVideo');
      this.youtubePlaying = false;
      this.$refs.play.querySelector('.video-play').classList.remove('hidden');
    } else {
      this.postYoutubeCommand('playVideo');
      this.youtubePlaying = true;
      this.$refs.play.querySelector('.video-play').classList.add('hidden');
    }
  }

  /**
   *
   */
  createYoutubeIframe() {
    const id = this.$options.youtubeId;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&enablejsapi=1&controls=0&playsinline=1&rel=0&loop=1&playlist=${id}`;
    iframe.allow = 'autoplay; encrypted-media';
    iframe.allowFullscreen = true;
    Object.assign(iframe.style, {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '300%',
      height: '100%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      pointerEvents: 'none',
    });

    this.$refs.youtubeContainer.classList.remove('hidden');
    this.$refs.youtubeContainer.append(iframe);
    this.youtubeIframe = iframe;

    if (this.$refs.poster) {
      this.$refs.poster.classList.add('hidden');
    }

    this.youtubePlaying = true;
    this.$refs.play.querySelector('.video-play').classList.add('hidden');
  }

  /**
   * @param {string} func
   */
  postYoutubeCommand(func) {
    if (this.youtubeIframe && this.youtubeIframe.contentWindow) {
      this.youtubeIframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func, args: [] }),
        '*',
      );
    }
  }

  /**
   *
   */
  onVolumeClick() {
    this.$refs.volume.classList.toggle('muted');

    if (this.isYoutube && this.youtubeIframe) {
      const isMuted = this.$refs.volume.classList.contains('muted');
      this.postYoutubeCommand(isMuted ? 'mute' : 'unMute');
    } else if (this.videoEl) {
      this.videoEl.muted = !this.videoEl.muted;
    }
  }
}
